/* eslint-disable no-unused-vars*/
import React from 'react';
/* eslint-enable no-unused-vars*/

/**
 * Transform string with all words starting with capitalized letter.
 * @param {string} text string to be capitalized.
 * @return {string} Capitalized string.
 */
function capitalizeText(text) {
  const words = text.split(' ');
  for (const word in words) {
    if (words.hasOwnProperty(word)) {
      if (typeof words[word] !== 'string') {
        return '';
      }
      words[word] = words[word].charAt(0).toUpperCase() + words[word].slice(1);
    }
  }

  return words.join(' ');
}

export default capitalizeText;
